import { Core } from "@faire/design-tokens";
import { IProductOption } from "@faire/web-api/indigofair/data/IProductOption";
import { IProductPageResponse } from "@faire/web-api/indigofair/data/IProductPageResponse";
import { Span } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import {
  getAvailableUnits,
  shouldShowAvailableUnits,
} from "../productAvailableUnits";

export const LowStockText: React.FunctionComponent<LowStockText.IProps> = ({
  product,
  selectedOption,
}) => {
  const availableUnits = getAvailableUnits(product, selectedOption);
  const showAvailableUnits = shouldShowAvailableUnits(
    product,
    availableUnits,
    selectedOption
  );

  if (!showAvailableUnits) {
    return null;
  }

  return (
    <LowStockSpan>
      <StrictLocalMsg
        defaultMessage="{availableUnitsNumber, plural, one{Only # left} other{Only # left}}"
        description={{
          text: "current remaining stock of this product on Faire",
          img: "https://cdn.faire.com/fastly/b86003d7c49c55f2db5cdc0e3c53998bd218b186ee70d426e19311bf1e5069ec.png",
        }}
        values={{ availableUnitsNumber: availableUnits }}
      />
    </LowStockSpan>
  );
};

namespace LowStockText {
  export interface IProps {
    product: IProductPageResponse.IPdpProduct;
    selectedOption?: IProductOption;
  }
}

const LowStockSpan = styled(Span)`
  &&& {
    color: ${Core.text.critical};
  }
`;
